import { Text, Button, Accordion } from '@/componentsV1/BaseComponents'
import './styles.scss'
import { useNavigate } from 'react-router-dom'
import { ImageBackgroundColors } from '@/styles'
import { LinkCard } from '@/ui'

export const AllDone = () => {
  const navigate = useNavigate()

  const handleBackClick = () => {
    navigate('/taxes/annual')
  }

  const steps = [
    {
      image: 'https://heard-images.s3.amazonaws.com/assets/group-clock.svg',
      imageAlt: 'group clock',
      color: ImageBackgroundColors.YELLOW,
      title: 'Wait for the bookkeeping team',
      description:
        'We’ll make sure that your books are in compliance, and you’ll have everything you need to prepare for taxes.',
    },
    {
      image: 'https://heard-images.s3.amazonaws.com/assets/note.svg',
      imageAlt: 'note',
      color: ImageBackgroundColors.ORANGE,
      title: 'Address bookkeeper follow-ups',
      description:
        'We’ll notify you via email if your bookkeeping team needs clarification on transactions or documents. ',
    },
    {
      image:
        'https://heard-images.s3.amazonaws.com/assets/circle-check-mark.svg',
      imageAlt: 'circle check mark',
      color: ImageBackgroundColors.GREEN,
      title: 'Sign off and finalize your books',
      description: (
        <>
          If everything is satisfactory, submit your sign-off to finalize your
          books for taxes.{' '}
          <span style={{ fontWeight: 'bold' }}>
            This is required to continue with the annual tax process.
          </span>
        </>
      ),
    },
  ]

  return (
    <div className="w-[920px] flex flex-col items-center">
      <div className="text-wrapper">
        <Text as="display2" style={{ marginBottom: '16px' }}>
          Sent to bookkeeping for review
        </Text>
        <Text as="bodyMd" style={{ marginBottom: '32px' }}>
          Thanks! The team will review your submission, and we’ll notify you
          when it’s time for you to approve their updates.
        </Text>

        <Accordion
          style={{ marginBottom: '40px' }}
          title="Why is my approval required for updates?"
          content={
            <Text as="bodySm">
              Before your books are closed for the year, your bookkeeper adjusts
              entries to meet accounting and tax requirements.
              <br />
              <br />
              Your review and sign-off are essential: they confirm that the
              adjustments are correct and that you agree with how your income
              and expenses are reported. This protects you from compliance
              issues and ensures your year-end reports are audit-ready.
            </Text>
          }
          variant="text"
        />
      </div>

      <Text as="h1" style={{ marginBottom: '24px', textAlign: 'center' }}>
        What to expect next
      </Text>

      <div className="flex gap-4">
        {steps.map((step) => (
          <LinkCard
            imageWidth={80}
            className="w-[230px]"
            imageSrc={step.image}
            imageAlt={step.imageAlt}
            imageColor={step.color}
            title={<Text as="h3">{step.title}</Text>}
            description={<Text as="bodySm">{step.description}</Text>}
            key={step.title}
          />
        ))}
      </div>
      <div className="flex justify-center">
        <Button
          className="return-end-of-year"
          variant="secondary"
          size="medium"
          onClick={handleBackClick}
        >
          Return to Year End
        </Button>
      </div>
    </div>
  )
}
